import {
  ClockCircleOutlined,
  EditOutlined,
  RightOutlined,
} from "@ant-design/icons";
import { Switch } from "@material-ui/core";
import { Avatar, Button as AntButton } from "antd";
import Axios from "axios";
import {  useEffect, useState } from "react";
import { HiMenuAlt3 } from "react-icons/hi";
import { useSelector } from "react-redux";
import AnalyticsGraph from "./components/AnalyticsGraph";
import AnalyticsChart from "./components/AnalyticsGraph";

export const Home = () => {
  const token = useSelector(
    (state) => state.delivery_user?.delivery_user?.data?.auth_token
  );

  const [shiftData, setShiftData] = useState(null);
  const [shiftDetails, setShiftDetails] = useState(null);
  const [shiftAnalytics, setShiftAnalytics] = useState(null);
  const [loading, setLoading] = useState(true);
  const [analyticsData, setAnalyticsData] = useState({
    orders: {},
    earnings: {},
  });

  useEffect(() => {
    if (!token) return;

    Axios.post("https://fleet.howincloud.com/api/v1/eatiko/shift/coming-up", {
      token: token,
    })
      .then((res) => {
        if (res.data.success && res.data.message) {
          setShiftData(res.data.message);
        }
      })
      .catch((err) => {
        console.error("Error fetching shift:", err);
      })
      .finally(() => setLoading(false));
  }, [token]);

  useEffect(() => {
    if (!token) return;

    // Shift details
    Axios.post("https://fleet.howincloud.com/api/v1/eatiko/shift/details", {
      token:token,
      shift_id: shiftData?.time_shift_id,
    })
      .then((res) => setShiftDetails(res.data))
      .catch(console.error);

    // Analytics graph
    Axios.post(
      "https://fleet.howincloud.com/api/v1/eatiko/shift/analytics-graph",
      {
        token:token
      }
    )
      .then((res) => {
        setShiftAnalytics(res.data);
        setAnalyticsData({
          orders: res.data?.orders || {},
          earnings: res.data?.earnings || {}
        });
      })
      .catch(console.error);
  }, [token, shiftData]);

  const onJoinShift = () => {
    const payload = {
      shift_id: shiftData.time_shift_id,
      token: token,
    };

    Axios.post("https://fleet.howincloud.com/api/v1/eatiko/shift/join", payload)
      .then((res) => {
        console.log("Joined shift successfully:", res.data);
      })
      .catch((err) => {
        console.error("Failed to join shift", err);
      });
  };

  const formatTime = (time24) => {
    if (!time24) return "";
    const [h, m] = time24.split(":");
    const hour = parseInt(h, 10);
    const suffix = hour >= 12 ? "pm" : "am";
    const hour12 = hour % 12 === 0 ? 12 : hour % 12;
    return `${hour12}:${m} ${suffix}`;
  };

  const getTimeLeft = (startTimeStr) => {
    const now = new Date();
    const [hours, minutes, seconds] = startTimeStr.split(":").map(Number);

    const shiftStart = new Date(now);
    shiftStart.setHours(hours, minutes, seconds || 0);

    const diffMs = shiftStart - now;
    const diffMins = Math.floor(diffMs / 1000 / 60);

    if (diffMins <= 0) return "Now";
    if (diffMins < 60) return `${diffMins} min${diffMins > 1 ? "s" : ""}`;
    const h = Math.floor(diffMins / 60);
    const m = diffMins % 60;
    return `${h}h ${m}m`;
  };


  const EarningsSummary = ({ data }) => {
    const [todayEarnings, setTodayEarnings] = useState(300);
    const [weekEarnings, setWeekEarnings] = useState(10000);
    const [activeTab, setActiveTab] = useState("today");

    useEffect(() => {
      if (!data || !data.success) return;
      
      // Calculate today's earnings
      const today = new Date().getDay(); // 0 (Sun) to 6 (Sat)
      const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      const todayKey = days[today];
      const todayData = data.earnings[todayKey];
      const todayEarnings = todayData ? 
        (typeof todayData.sum === "string" ? parseFloat(todayData.sum) : todayData.sum || 0) : 0;
      
      // Calculate week earnings
      const weekEarnings = Object.values(data.earnings).reduce((total, day) => {
        const daySum = typeof day.sum === "string" ? parseFloat(day.sum) : day.sum || 0;
        return total + daySum;
      }, 0);

      setTodayEarnings(todayEarnings);
      setWeekEarnings(weekEarnings);
    }, [data]);

    return (
      <div
        className="mb-3"
        style={{
          backgroundColor: "#E2D3FE",
          borderRadius: "20px",
          padding: "15px",
        }}
      >
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h4
            className="m-0 fw-semibold"
            style={{ fontSize: "36px", fontWeight: "600" }}
          >
            ₹ {activeTab === "today" ? todayEarnings.toLocaleString('en-IN') : weekEarnings.toLocaleString('en-IN')}
          </h4>
          <div>
            <button
              onClick={() => setActiveTab("today")}
              style={{
                backgroundColor: activeTab === "today" ? "white" : "transparent",
                color: "black",
                borderRadius: "5px",
                border: "none",
                padding: "4px 12px",
                fontWeight: "bold",
                marginRight: "8px",
                cursor: "pointer",
                outline: "none",
              }}
            >
              Today
            </button>
            <button
              onClick={() => setActiveTab("week")}
              style={{
                backgroundColor: activeTab === "week" ? "#CCBAED" : "transparent",
                color: "black",
                borderRadius: "5px",
                border: "none",
                padding: "4px 12px",
                fontWeight: "bold",
                cursor: "pointer",
                outline: "none",
              }}
            >
              This week
            </button>
          </div>
        </div>
        <div className="text-muted">
          {activeTab === "today" ? "Today's Earnings" : "This Week's Earnings"}
        </div>
      </div>
    );
  };

  return (
    <div className="bg-light min-vh-100" style={{ padding: "2rem" }}>
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="d-flex align-items-center">
          <Avatar
            shape="square"
            size={64}
            src="https://randomuser.me/api/portraits/men/75.jpg"
            style={{
              backgroundColor: "#fde3cf",
              marginRight: "1rem",
              borderRadius: "30%",
            }}
          />
          <div>
            <div
              className="text-muted"
              style={{ fontSize: "24px", lineHeight: "24px" }}
            >
              Hello
            </div>
            <div
              style={{
                fontWeight: "600",
                fontSize: "24px",
                lineHeight: "24px",
                color: "black",
              }}
            >
              Nashidh
            </div>
            <div>
              <a
                href="#"
                className="text-decoration-none"
                style={{
                  fontSize: "0.9rem",
                  color: "#3853EA",
                  fontSize: "12px",
                }}
              >
                Complete Profile <EditOutlined />
              </a>
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center gap-3">
          <Switch size="large" />
          <HiMenuAlt3 size={24} style={{ color: "black" }} />
        </div>
      </div>

      {/* Refer & Earn Banner */}
      <div
        className="d-flex justify-content-between align-items-center px-3 py-2 mb-3"
        style={{
          background: "linear-gradient(to right, #A1AFFF, #3853EA)",
          color: "#fff",
          fontWeight: "600",
          fontSize: "14px",
          borderRadius: "5px",
        }}
      >
        <div>Refer Friend & Earn</div>
        <div
          className="bg-white px-3 py-1"
          style={{
            fontWeight: "700",
            borderRadius: "5px",
            color: "#3853EA",
            fontSize: "14px",
          }}
        >
          Upto ₹3000
        </div>
      </div>

      {/* Shift Notification Card */}
      {shiftData && (
        <div
          className="text-white mb-3"
          style={{
            borderRadius: "20px",
            background: "#121B60",
            padding: "25px",
          }}
        >
          <div
            className="mb-2"
            style={{ fontSize: "1.1rem", fontWeight: "bold" }}
          >
            Shift Starts in {getTimeLeft(shiftData.start_time)}!
          </div>

          <div className="d-flex align-items-center mb-3">
            <ClockCircleOutlined
              className="me-2"
              style={{ marginRight: "10px" }}
            />
            <span>
              {formatTime(shiftData.start_time)} -{" "}
              {formatTime(shiftData.end_time)}
            </span>
          </div>

          <AntButton
            type="primary"
            block
            style={{
              background: "#3853EA",
              fontWeight: "bold",
              borderRadius: "10px",
              fontSize: "16px",
            }}
            onClick={onJoinShift}
          >
            Go Online now!
          </AntButton>
        </div>
      )}

      {/* Add Bank Details */}
      <div
        className="bg-white d-flex justify-content-between align-items-center shadow-sm"
        style={{
          borderRadius: "15px",
          border: "1px solid #00000014",
          padding: "20px",
          marginBottom: "20px",
        }}
      >
        <div style={{ color: "black" }}>
          Add{" "}
          <span className="fw-bold" style={{ color: "#3853EA" }}>
            Bank Details
          </span>
        </div>
        <RightOutlined style={{ color: "#3853EA" }} />
      </div>

      {/* Earnings Card - Updated with dynamic data */}
      <EarningsSummary data={analyticsData} />

      {/* Orders & Online Hours */}
      <div className="d-flex gap-3 flex-wrap mb-4">
        {/* Orders Card */}
        <div
          className="flex-fill p-3 text-dark"
          style={{
            backgroundColor: "#c5ecff",
            borderRadius: "20px",
            minWidth: "160px",
            marginRight: "1rem",
          }}
        >
          <div className="d-flex justify-content-between align-items-center mb-1">
            <span style={{ fontSize: "1.5rem", fontWeight: "600" }}>
              {shiftDetails?.completed_orders ?? "--"}
            </span>
            <span
              className="badge bg-light text-dark"
              style={{ fontWeight: "500" }}
            >
              {shiftDetails?.required_orders ?? "--"}
            </span>
          </div>
          <div className="mb-2">
            <div
              className="d-flex justify-content-between align-items-center px-1"
              style={{ opacity: 0.5 }}
            >
              {[...Array(5)].map((_, idx) => (
                <div
                  key={idx}
                  style={{
                    width: "6px",
                    height: "6px",
                    borderRadius: "50%",
                    background: "#7dbcd1",
                  }}
                />
              ))}
            </div>
          </div>
          <div style={{ fontWeight: "500" }}>Orders</div>
        </div>

        {/* Online Time Card */}
        <div
          className="flex-fill p-3 text-dark"
          style={{
            backgroundColor: "#d6f8c3",
            borderRadius: "20px",
            minWidth: "160px",
          }}
        >
          <div
            className="d-flex align-items-end"
            style={{ fontWeight: "600", fontSize: "1.25rem" }}
          >
            <span>{shiftDetails?.remaining_time?.split(":")[0] ?? "--"}</span>
            <span
              className="ms-1"
              style={{
                fontSize: "0.75rem",
                background: "#d0e8b2",
                borderRadius: "5px",
                padding: "0 4px",
              }}
            >
              Hr
            </span>
            <span className="ms-2">
              {shiftDetails?.remaining_time?.split(":")[1] ?? "--"}
            </span>
            <span
              className="ms-1"
              style={{
                fontSize: "0.75rem",
                background: "#d0e8b2",
                borderRadius: "5px",
                padding: "0 4px",
              }}
            >
              mins.
            </span>
          </div>
          <div className="d-flex justify-content-between align-items-center">
            <div className="mt-1">
              Out of <strong>{shiftDetails?.shift?.total_hours}h</strong>
            </div>
            <ClockCircleOutlined style={{ opacity: 0.3, fontSize: "18px" }} />
          </div>
        </div>
      </div>

      {/* Incentive Section */}
      <div
  className="bg-white border p-3 mb-4 shadow-sm"
  style={{ borderRadius: "15px" }}
>
  <div className="d-flex justify-content-between align-items-center mb-2">
    <div>
      <span className="fw-bold" style={{ color: "black", fontSize: "16px" }}>
        Login
      </span>{" "}
      <span className="fw-bold" style={{ color: "#3853EA", fontSize: "16px" }}>
        Incentive Today
      </span>
    </div>
    <RightOutlined style={{ color: "#3853EA", fontSize: "16px" }} />
  </div>

  {/* Progress bar */}
  <div
    className="p-3 mb-3"
    style={{ backgroundColor: "#eef0ff", borderRadius: "15px" }}
  >
    <div
      className="d-flex justify-content-between align-items-center mb-2"
      style={{ fontSize: "12px", color: "black" }}
    >
      <span>
        Trips Count:{" "}
        <strong>
          {console.log(shiftDetails?.completed_orders)}
          {shiftDetails?.completed_orders ?? 0}
        </strong>
      </span>
      <span className="badge  text-white" style={{backgroundColor:"#3853EA"}}>
        ₹{shiftDetails?.login_incentive_amount ?? "--"}
      </span>
    </div>
    <div
      className="position-relative"
      style={{
        height: "10px",
        backgroundColor: "#cbd5ff",
        borderRadius: "5px",
      }}
    >
      <div
        style={{
          width: `${Math.min(
            (shiftDetails?.completed_orders || 0) / 
            Math.max(shiftDetails?.required_orders || 1, 1) * 100,
            100
          )}%`,
          height: "100%",
          backgroundColor: "#3b5bff",
          borderRadius: "5px",
          position: "relative",
          transition: "width 0.3s ease",
        }}
      >
        <div
          style={{
            width: "16px",
            height: "16px",
            backgroundColor: "#3b5bff",
            borderRadius: "50%",
            position: "absolute",
            right: "0",
            top: "-3px",
            border: "2px solid white",
            display: shiftDetails?.completed_orders >= shiftDetails?.required_orders ? "none" : "block",
          }}
        />
        {shiftDetails?.completed_orders >= shiftDetails?.required_orders && (
          <div
            style={{
              position: "absolute",
              right: "-5px",
              top: "-5px",
              color: "white",
              backgroundColor: "#3853EA",
              borderRadius: "50%",
              width: "20px",
              height: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "12px",
            }}
          >
            ✓
          </div>
        )}
      </div>
    </div>
   
  </div>

  <AntButton
    type="primary"
    block
    style={{
      background: "#3253f5",
      borderRadius: "10px",
      fontWeight: "bold",
    }}
  >
    View all Incentives <RightOutlined />
  </AntButton>
</div>
      
      {/* Analytics Chart */}
      <AnalyticsChart data={analyticsData} />
    </div>
  );
};